<script setup>

import { watch } from 'vue'
import { useToast } from "primevue/usetoast"
import { useNotificationStore } from '@/stores/notification'
import { storeToRefs } from 'pinia';
const toast = useToast()

const notificationStore = useNotificationStore()

const { nbrOfAlerts, nbrOfMessages, alerts, messages } = storeToRefs(notificationStore)

watch(nbrOfAlerts, () => {
    alerts.value.forEach(alert => {
        let newAlert = alert
        newAlert.group = "alert"
        toast.add(newAlert)
    });
    notificationStore.clearAlerts()
})

watch(nbrOfMessages, () => {
    messages.value.forEach(alert => {
        let newMessage = alert
        newMessage.group = "message"
        toast.add(newMessage)
    });
    notificationStore.clearMessages()
})

</script>

<template>
    <pv-toast position="top-right" group="alert" />
    <pv-toast position="bottom-center" group="message" />
</template>